/**
 * Helpers de status compartilhados entre views (lista e detalhe).
 * Single source of truth pra label PT-BR + classe CSS de badge.
 */

import type { StatusProposta } from '@infomatic/shared';

const LABELS: Record<StatusProposta, string> = {
  rascunho: 'Rascunho',
  enviada: 'Enviada',
  visualizada: 'Visualizada',
  aceita: 'Aceita',
  'aguardando-dados-contrato': 'Aguardando dados',
  'contrato-gerado': 'Contrato gerado',
  'aguardando-assinatura': 'Aguardando assinatura',
  assinada: 'Assinada',
  implantacao: 'Em implantação',
  concluida: 'Concluída',
  perdida: 'Perdida',
  cancelada: 'Cancelada',
};

/** Classes de badge (alinhadas com tokens.css: ok/warn/info/seen/neutral/error) */
const BADGE_CLASSES: Record<StatusProposta, string> = {
  rascunho: 'neutral',
  enviada: 'info',
  visualizada: 'seen',
  aceita: 'ok',
  'aguardando-dados-contrato': 'warn',
  'contrato-gerado': 'info',
  'aguardando-assinatura': 'warn',
  assinada: 'ok',
  implantacao: 'info',
  concluida: 'ok',
  perdida: 'error',
  cancelada: 'error',
};

export function formatStatus(s: StatusProposta): string {
  return LABELS[s] ?? s;
}

export function badgeClass(s: StatusProposta): string {
  return BADGE_CLASSES[s] ?? 'neutral';
}
